import { useContext } from 'react';
import { ProjectContext } from './ProjectContext';

// Kept separate from ProjectContext.tsx so that file only exports components (react-refresh).
export function useProject() {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
}
